import { createThemeCompiler } from '../../../utils';

export const flyoutThemeCompiler = createThemeCompiler(({ palette }) => ({
    flyout: {
        colors: {
            borderColor: palette.neutralTertiary,
            backgroundColor: palette.white,
            closeButtonColor: palette.neutralPrimary,
            modalBackgroundColor: palette.black,
            titleSeparatorColor: palette.neutralQuaternary
        },
        composites: {}
    }
}));
